const Getters = {
  getOrderListFromState: (state) => {
    return state.orderList
  },
  getOrderIncompleteListFromState: (state) => {
    return state.orderIncompleteList
  },
  getMetaAndSummaryFromState: (state) => {
    return [state.meta, state.summary]
  },
  getOrderListAllResponseFromState: (state) => {
    return state
  },
  getOrderPaymentListFromState: (state) => {
    return state.orderPaymentList
  },
  getOrderDetailListFromState: (state) => {
    return state.orderDetailList
  },
  getBulkOperationCompletedFromState: (state) => {
    return state.bulkOperationCompleted
  }
}

export default Getters
